<template>
    <page title="newCompetitionApprovalTitle" :textHeight="(WindowSize.y - 276) + 'px'">
        <template #pageContainer>
            <v-form ref="form" v-model="valid">
				<v-row><v-col>
                <v-autocomplete outlined dense
					hide-details="auto"
                    v-model="type.selected"
                    :items="type.items"
                    :label="$t('text.type')+'*'"
                    :error-messages="errors('type')"
					:rules="[rules.notEmpty]"
                    required
					:readonly="isViewMode"
                    @input="$v.type.selected.$touch()"
                    @blur="$v.type.selected.$touch()">
                </v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
				<v-text-field outlined dense
					hide-details="auto"
					class="mt-0 pt-0"
					:clearable="!isViewMode"
					v-model="name"
					:label="$t('text.headerCompetitionName')+'*'"
                    :error-messages="errors('name')"
					:rules="[rules.notEmpty, rules.maxLen200]"
                    required
					:readonly="isViewMode"
                    @input="$v.name.$touch()"
                    @blur="$v.name.$touch()">
				</v-text-field>
				</v-col></v-row>
				<v-row><v-col cols="12" sm="12" lg="6">
				<v-menu
					v-model="manuStart"
					:disabled="isViewMode"
					:close-on-content-click="false"
					max-width="290">
					<template #activator="{ on }">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							:value="formattedDate(startDate)"
							:clearable="!isViewMode"
							:label="$t('text.startDate')+'*'"
							:error-messages="errors('startDate')"
							:rules="[rules.notEmpty,rules.validStartFuture]"
							required
							readonly
							v-on="on"
							@input="$v.startDate.$touch()"
							@blur="$v.startDate.$touch()"
							@click:clear="startDate = null">
						</v-text-field>
					</template>
					<v-date-picker
						locale="DE-de"
						v-model="startDate"
						@change="manuStart = false"
						@input="setDates">
					</v-date-picker>
				</v-menu>
				</v-col><v-col cols="12" sm="12" lg="6">
					<v-text-field outlined dense
						hide-details="auto"
						:clearable="!isViewMode"
						class="mt-0 pt-0"
						v-model="startTime"
						:label="$t('text.startTime')+'*'"
						:error-messages="errors('startTime')"
						:rules="[rules.notEmpty, rules.isTime]"
						required
						@keyup="formatStartTime">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
				<v-menu
					v-model="menuEnd"
					:disabled="isViewMode"
					:close-on-content-click="false"
					max-width="290">
					<template #activator="{ on }">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							:value="formattedDate(endDate)"
							:clearable="!isViewMode"
							:rules="[rules.validStartEnd,rules.validDeltaDate]"
							:label="$t('text.endDate')"
							readonly
							v-on="on"
							@click:clear="endDate = null">
						</v-text-field>
					</template>
					<v-date-picker
						locale="DE-de"
						v-model="endDate"
						@change="menuEnd = false">
					</v-date-picker>
				</v-menu>
				</v-col></v-row>
				<v-row><v-col>
				<v-menu
					v-model="menuClosing"
					:disabled="isViewMode"
					:close-on-content-click="false"
					max-width="290">
					<template #activator="{ on }">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							:value="formattedDate(closingDate)"
							:clearable="!isViewMode"
							:label="$t('text.closingDate')"
							readonly
							v-on="on"
							@click:clear="closingDate = null">
						</v-text-field>
					</template>
					<v-date-picker
										locale="DE-de"
						v-model="closingDate"
						@change="menuClosing = false">
					</v-date-picker>
				</v-menu>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						v-model="country.selected"
						:items="nationsList"
						:label="$t('text.country')+'*'"
						:error-messages="errors('country')"
						:rules="[rules.notEmpty]"
						:readonly="isViewMode"
						required
						disabled
						@input="$v.country.selected.$touch()"
						@blur="$v.country.selected.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						v-model="owner.selected"
						:items="owner.items"
						:label="$t('text.organisator')+'*'"
						:error-messages="errors('owenr')"
						:rules="[rules.notEmpty]"
						:disabled="isNonMasterOrga"
						required
						:readonly="isViewMode"
						:no-data-text="$t('text.insertSearchText')"
						:clearable="!isViewMode"
						@click:clear="clearOwner()"
						@keyup="searchOrgas"
						@input="$v.owner.selected.$touch()"
						@blur="$v.owner.selected.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<c-checkbox v-model="nonProfit" :readonly="isViewMode" :text="$t('text.compApprovalBillingInfo')"></c-checkbox>
				</v-col></v-row>
				<v-row v-if="nonProfit"><v-col>
					<v-text-field outlined dense
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="nonProfitReason"
						:label="$t('text.compApprovalBillingUsage')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<c-checkbox v-model="fees"  :readonly="isViewMode" :text="$t('text.compApprovalFeeInfo')"></c-checkbox>
				</v-col></v-row>
				<v-row><v-col>
					<h2>{{$t('text.headerStatisticData')}}</h2>
				</v-col></v-row>
				<v-row><v-col>
					<c-checkbox v-model="firstTimeEvent" :readonly="isViewMode" :text="$t('text.firstTimeEvent')"></c-checkbox>
				</v-col></v-row>
				<v-row><v-col>
					<h2>{{$t('text.headerContactAddress')}}</h2>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						v-model="contact.title.selected"
						:readonly="isViewMode"
						:items="contact.title.items"
						:label="$t('text.title')">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.firstName"
						:label="$t('text.firstName')+'*'"
						:error-messages="errors('firstname')"
						:rules="[rules.notEmpty, rules.maxLen200]"
						:readonly="isViewMode"
						required
						@input="$v.contact.firstName.$touch()"
						@blur="$v.contact.firstName.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.lastName"
						:label="$t('text.lastName')+'*'"
						:error-messages="errors('lastname')"
						:rules="[rules.notEmpty, rules.maxLen200]"
						required
						@input="$v.contact.lastName.$touch()"
						@blur="$v.contact.lastName.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.street"
						:rules="[rules.notEmpty, rules.maxLen200]"
						:label="$t('text.streetNr')+'*'">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.streetAdd"
						:rules="[rules.maxLen200]"
						:label="$t('text.addStreet')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col cols="12"  sm="4" lg="4">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.zip"
						:rules="[rules.notEmpty, rules.maxLen30]"
						:label="$t('text.zip')+'*'">
					</v-text-field>
				</v-col><v-col cols="12"  sm="8" lg="8">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.town"
						:rules="[rules.notEmpty, rules.maxLen200]"
						:label="$t('text.place')+'*'">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.phone"
						:rules="[rules.maxLen20]"
						:label="$t('text.phone')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.mobile"
						:rules="[rules.maxLen20]"
						:label="$t('text.mobile')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.fax"
						:rules="[rules.maxLen20]"
						:label="$t('text.fax')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="contact.email"
						:label="$t('text.email')+'*'"
						:error-messages="errors('email')"
						:rules="[rules.notEmpty, rules.email]"
						required
						@input="$v.contact.email.$touch()"
						@blur="$v.contact.email.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						@keyup="formatWeb(contact.web)"
						v-model="contact.web"
						:rules="[rules.maxLen200]"
						:label="$t('text.homepage')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						@keyup="formatEntrySys(linkEntrySystem)"
						v-model="linkEntrySystem"
						:label="$t('text.reportingPortalLink')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<h2>{{$t('text.additionalConactInfo')}}</h2>
				</v-col></v-row>
				<v-row><v-col>
					<v-textarea
						hide-details="auto"
						outlined dense
						:readonly="isViewMode"
						v-model="contact.note"
						:placeholder="$t('text.additionalConactInfoPlaceholder')"
					></v-textarea>
				</v-col></v-row>
				<v-row><v-col>
					<h2>{{$t('text.competitionLocation')}}</h2>
				</v-col></v-row>
				<v-row><v-col>
                <v-autocomplete outlined dense
					hide-details="auto"
					:readonly="isViewMode"
                    v-model="regionGuid.selected"
                    :items="regionGuid.items"
					:loading="regionGuid.loading"
                    :label="$t('text.stateAssociation')+'*'"
                    :error-messages="errors('regionGuid')"
					:rules="[rules.notEmpty]"
                    required
                    @input="$v.regionGuid.selected.$touch()"
                    @blur="$v.regionGuid.selected.$touch()">
                </v-autocomplete>
				</v-col></v-row>
				<v-row v-if="isRegionSelected && areaGuid.items.length != 0"><v-col>
                <v-autocomplete outlined dense
					hide-details="auto"
					:readonly="isViewMode"
                    v-model="areaGuid.selected"
                    :items="areaGuid.items"
					:loading="areaGuid.loading"
                    :label="$t('text.areaAssociation')">
                </v-autocomplete>
				</v-col></v-row>
				<v-row v-if="isRegionSelected && districtGuid.items.length != 0"><v-col>
                <v-autocomplete outlined dense
					hide-details="auto"
					:readonly="isViewMode"
                    v-model="districtGuid.selected"
                    :items="districtGuid.items"
					:loading="districtGuid.loading"
                    :label="$t('text.districtAssociation')">
                </v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.startLocation"
						:label="$t('text.startLocation')+'*'"
						:error-messages="errors('startLocation')"
						:rules="[rules.notEmpty, rules.maxLen200]"
						required
						@input="$v.competition.startLocation.$touch()"
						@blur="$v.competition.startLocation.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.street"
						:label="$t('text.street')+'*'"
						:error-messages="errors('competitionStreet')"
						:rules="[rules.notEmpty, rules.maxLen200]"
						required
						@input="$v.competition.street.$touch()"
						@blur="$v.competition.street.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col cols="12"  sm="4" lg="4">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.zip"
						:label="$t('text.zip')+'*'"
						:error-messages="errors('competitionzip')"
						:rules="[rules.notEmpty, rules.maxLen30]"
						required
						@input="$v.competition.zip.$touch()"
						@blur="$v.competition.zip.$touch()">
					</v-text-field>
				</v-col><v-col cols="12"  sm="8" lg="8">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.town"
						:label="$t('text.place')+'*'"
						:error-messages="errors('competitiontown')"
						:rules="[rules.notEmpty, rules.maxLen200]"
						required
						@input="$v.competition.town.$touch()"
						@blur="$v.competition.town.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col cols="12"  sm="6" lg="6">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.gps.lat"
						:label="$t('text.gps1')">
					</v-text-field>
				</v-col><v-col cols="12"  sm="6" lg="6">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.gps.lng"
						:label="$t('text.gps2')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<h2>{{$t('text.differentRoute')}}</h2>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.alt.street"
						:rules="[rules.maxLen200]"
						:label="$t('text.street')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col cols="12"  sm="4" lg="4">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.alt.zip"
						:rules="[rules.maxLen30]"
						:label="$t('text.zip')">
					</v-text-field>
				</v-col><v-col cols="12"  sm="8" lg="8">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.alt.town"
						:rules="[rules.maxLen200]"
						:label="$t('text.place')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col cols="12"  sm="6" lg="6">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.alt.gps.lat"
						:label="$t('text.gps1')">
					</v-text-field>
				</v-col><v-col cols="12"  sm="6" lg="6">
					<v-text-field outlined dense
						hide-details="auto"
						:readonly="isViewMode"
						class="mt-0 pt-0"
						:clearable="!isViewMode"
						v-model="competition.alt.gps.lng"
						:label="$t('text.gps2')">
					</v-text-field>
				</v-col></v-row>
            </v-form>

            <spinner :loading="loading"></spinner>
        </template>
		<template #pageActions>
			<pop-up v-model="confirmOverwrite"
				:show="showConfirmOverwrite"
				title="dialogText.reallySave"
				text="editCompApprovalHINT"
				:hardText="getChanges"
				type="confirm"
				width="70%"
				@close="onConfirmClose">
			</pop-up>
			<v-row><v-col>
				<v-btn
                    class="mr-4"
					v-if="isViewMode"
                    @click="backToOverview">
                    {{ $t(`text.backToOverview`) }}
                </v-btn>
				<v-btn
                    class="mr-4"
					v-if="isViewMode"
                    @click="saveAndNext">
                    {{ $t(`text.next`) }}
                </v-btn>
                <v-btn
                    class="mr-4"
					v-if="!isViewMode"
                    :disabled="loading"
                    @click="save">
                    {{ $t(`text.save`) }}
                </v-btn>
				<v-btn
                    class="mr-4"
					v-if="!isViewMode"
                    :disabled="loading"
                    @click="saveAndNext">
                    {{ $t(`text.createAndNext`) }}
                </v-btn>

                <v-btn
                    :disabled="loading"
                    class="mr-4"
                    @click="back">
                    {{ $t(`text.backButton`) }}
                </v-btn>
			</v-col></v-row>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';
import CCheckbox from '../general/CCheckbox.vue';
import PopUp from '../general/PopUp.vue';

import compApprovalActions from '../store/actions/compApproval';
import organizationActions from '../store/actions/organization';
import namespace from '../store/namespace';

import modelState from '../mixins/modelState';
import getIOC from '../models/IOC';

export default {
	name: 'NewCompetitionApproval',
	mixins: [modelState],
	components: {
		Page,
		Spinner,
		CCheckbox,
		PopUp,
	},
	validations: {
		type: {
			selected: {
				required,
			},
		},
		name: {
			required,
		},
		startDate: {
			required,
		},
		startTime: {
			required,
		},
		country: {
			selected: {
				required,
			},
		},
		owner: {
			selected: {
				required,
			},
		},
		firstTimeEvent: {
			required,
		},
		contact: {
			firstName: {
				required,
			},
			lastName: {
				required,
			},
			email: {
				required,
			},
		},
		regionGuid: {
			selected: {
				required,
			},
		},
		competition: {
			street: {
				required,
			},
			town: {
				required,
			},
			zip: {
				required,
			},
			startLocation: {
				required,
			},
		},
	},
	data() {
		return {
			valid: true,
			type: {
				selected: null,
				items: [
					{ text: '-- bitte wählen --', value: null },
					{ text: 'Stadionfern - vermessen', value: 0 },
					{ text: 'Stadionfern - unvermessen', value: 1 },
					{ text: 'Stadionfern - gemischt', value: 2 },
				],
			},
			name: null,
			linkEntrySystem: null,
			startDate: null,
			manuStart: false,
			startTime: null,
			menuTime: false,
			endDate: null,
			menuEnd: false,
			closingDate: null,
			menuClosing: false,
			country: {
				selected: 'GER',
			},
			owner: {
				items: [],
				selected: null,
			},
			nonProfit: false,
			nonProfitReason: null,
			fees: true,
			firstTimeEvent: true,
			contact: {
				title: {
					selected: 2,
					items: [{ text: this.$i18n.t('text.mr'), value: 0 }, { text: this.$i18n.t('text.mrs'), value: 1 }, { text: this.$i18n.t('text.none'), value: 2 }, { text: this.$i18n.t('text.company'), value: 3 }],
				},
				firstName: null,
				lastName: null,
				street: null,
				streetAdd: null,
				zip: null,
				town: null,
				phone: null,
				mobile: null,
				fax: null,
				email: null,
				web: null,
				note: null,
			},
			regionGuid: {
				items: [],
				selected: null,
				loading: false,
			},
			areaGuid: {
				items: [],
				selected: null,
				loading: false,
			},
			districtGuid: {
				items: [],
				selected: null,
				loading: false,
			},
			competition: {
				startLocation: null,
				street: null,
				zip: null,
				town: null,
				gps: {
					lng: null,
					lat: null,
				},
				alt: {
					street: null,
					zip: null,
					town: null,
					gps: {
						lng: null,
						lat: null,
					},
				},
			},
			ownerLoading: false,
			loading: false,
			rules: {
				notEmpty: v => (v !== null && String(v).trim() !== '') || this.$i18n.t('text.errorEmpty'),
				email: v => /[ßäöüÄÖÜa-zA-Z0-9._%+-]+@[ßäöüÄÖÜa-zA-Z0-9.-]+\.[a-zA-Z]{2,9}/.test(v) || this.$i18n.t('text.errorInvalidEmail'),
				isTime: v => /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/.test(v) || this.$i18n.t('text.errorInvalidInput'),
				validStartEnd: (v) => {
					if (v == null || v == '') return true;
					const end = this.$moment(this.endDate);
					const start = this.$moment(this.startDate);
					return (end.isValid() && start.isValid() && end >= start) || this.$i18n.t('text.errorEndBeforeStart');
				},
				validDeltaDate: (v) => {
					if (v == null || v == '') return true;
					const end = this.$moment(this.endDate);
					const start = this.$moment(this.startDate);
					const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
					const diffDays = Math.round(Math.abs((end - start) / oneDay));
					return (end.isValid() && diffDays < 100) || this.$i18n.t('text.errorEventTooLong');
				},
				validStartFuture: (v) => {
					if (v == null || v == '') return true;
					const start = this.$moment(this.startDate);
					const future = new Date();
					future.setDate(future.getDate() + 2000);
					const past = new Date(2010, 1, 1);
					return (start.isValid() && start < future && start > past) || this.$i18n.t('text.errorStartDateInvalid');
				},
				maxLen20: v => (v == null || v.length <= 20) || this.$i18n.t('text.toLong'),
				maxLen30: v => (v == null || v.length <= 30) || this.$i18n.t('text.toLong'),
				maxLen200: v => (v == null || v.length <= 200) || this.$i18n.t('text.toLong'),
			},
			newComp: null,
			pristineComp: {
				startDate: null,
				owner: { value: null, text: '' },
				regionGuid: { value: null, text: '' },
				areaGuid: { value: null, text: '' },
				districtGuid: { value: null, text: '' },
				town: null,
			},
			confirmOverwrite: 1,
			showConfirmOverwrite: false,
			next() {},
		};
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.COMPETITIONAPPROVAL, ['CompApprLinks', 'Competition']),
		...mapGetters(namespace.ORGANIZATION, ['SelectedOrganization']),
		nationsList() {
			return getIOC();
		},
		cGuid() {
			if (this.$route.params.cGuid) return this.$route.params.cGuid;
			if (this.newComp) return this.newComp.id;
			return null;
		},
		isEditMode() {
			return !!this.cGuid;
		},
		isViewMode() {
			return this.$route.name === 'showcompetitionapproval';
		},
		isNonMasterOrga() {
			return this.SelectedOrganization && ['Club', 'LG', 'StG', 'Company'].includes(this.SelectedOrganization.orgType);
		},
		isRegionSelected() {
			return !!this.regionGuid.selected;
		},
		isPristine() {
			return this.startDate == this.pristineComp.startDate
					&& this.owner.selected == this.pristineComp.owner.value
					&& this.regionGuid.selected == this.pristineComp.regionGuid.value
					&& this.areaGuid.selected == this.pristineComp.areaGuid.value
					&& this.districtGuid.selected == this.pristineComp.districtGuid.value
					&& this.competition.town == this.pristineComp.town;
		},
		isStatusResetting() {
			return this.isEditMode && !this.isPristine && ![0, 2].includes(this.Competition?.competitionState);
		},
		getChanges() {
			const changes = [];
			if (this.startDate != this.pristineComp.startDate) changes.push(`${this.$t('text.startDate')}: ${this.pristineComp.startDate} => ${this.startDate}`);
			if (this.owner.selected != this.pristineComp.owner.value) changes.push(`${this.$t('text.organisator')}: ${this.pristineComp.owner.text} => ${this.filterOwnerById(this.owner.selected).text}`);
			if (this.regionGuid.selected != this.pristineComp.regionGuid.value) changes.push(`${this.$t('text.stateAssociation')}: ${this.pristineComp.regionGuid.text} => ${this.filterRegionById(this.regionGuid.selected).text}`);
			if (this.areaGuid.selected != this.pristineComp.areaGuid.value) changes.push(`${this.$t('text.areaAssociation')}: ${this.pristineComp.areaGuid.text} => ${this.filterAreaById(this.areaGuid.selected).text}`);
			if (this.districtGuid.selected != this.pristineComp.districtGuid.value) changes.push(`${this.$t('text.districtAssociation')}: ${this.pristineComp.districtGuid.text} => ${this.filterDistrictById(this.districtGuid.selected).text}`);
			if (this.competition.town != this.pristineComp.town) changes.push(`${this.$t('text.town')}: ${this.pristineComp.town} => ${this.competition.town}`);
			return changes.join('\r\n');
		},
	},
	watch: {
		SelectedOrganization() {
			if (!this.owner.selected) {
				this.owner.selected = this.SelectedOrganization.value;
			}
		},
		'owner.selected': function () {
			if (this.owner.selected) this.getOwnerItems();
		},
		'regionGuid.selected': function () {
			this.getAreaOrganization();
			this.getDistrictOrganization();
		},
	},
	async mounted() {
		this.loading = true;
		if (this.CompApprLinks.length === undefined || this.CompApprLinks.length === 0) {
			await this.GET_COMP_APPROVAL_LINKS();
		}
		if (this.isEditMode || this.isViewMode) {
			if (!this.Competition || this.Competition.id !== this.cGuid) {
				const link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
				if (link) {
					await this.GET_COMP_BY_ID({ link, cGuid: this.cGuid });
					this.readFromDTO();
				}
			} else {
				this.readFromDTO();
			}
		} else {
			this.SET_COMPETITION({});
		}
		this.getRegionOrganization();
		if (this.SelectedOrganization && !this.owner.selected) this.owner.selected = this.SelectedOrganization.value;
		this.loading = false;
	},
	methods: {
		...mapActions(namespace.COMPETITIONAPPROVAL, [
			compApprovalActions.GET_COMP_APPROVAL_LINKS,
			compApprovalActions.NEW_COMP_APPROVAL,
			compApprovalActions.GET_COMP_BY_ID,
			compApprovalActions.UPDATE_COMP_APPROVAL,
		]),
		...mapActions(namespace.ORGANIZATION, [
			organizationActions.GET_ORGANIZATIONS_BY_NAME,
			organizationActions.GET_ORGANIZATION_BY_GUID,
			organizationActions.GET_ORGANIZATIONS_BY_TYPE,
			organizationActions.GET_ORGANIZATIONS_BY_TYPE_PARENT,
		]),
		...mapMutations(namespace.COMPETITIONAPPROVAL, [
			compApprovalActions.SET_COMPETITION,
		]),
		filterOwnerById(id) {
			return this.owner.items.find(x => x.value == id) || {};
		},
		filterAreaById(id) {
			return this.areaGuid.items.find(x => x.value == id) || {};
		},
		filterDistrictById(id) {
			return this.districtGuid.items.find(x => x.value == id) || {};
		},
		filterRegionById(id) {
			return this.regionGuid.items.find(x => x.value == id) || {};
		},
		formatStartTime() {
			let value = this.startTime;

			if (value) {
				value = value.replace(/^[0]+|[^0-9]/g, '').padStart(4, 0);
				value = `${value.slice(0, -2)}:${value.slice(-2)}`;
				this.startTime = value;
			}
		},
		formatWeb(link) {
			if (link && !link.startsWith('http')) this.contact.web = `http://${link}`;
		},
		formatEntrySys(link) {
			if (link && !link.startsWith('http')) this.linkEntrySystem = `http://${link}`;
		},
		setDates() {
			this.endDate = !this.endDate ? this.startDate : '';
			this.closingDate = !this.closingDate ? this.startDate : '';
		},
		clearOwner() {
			this.owner.items = [];
		},
		async save() {
			this.$refs.form.validate();
			if (!this.$v.$invalid && this.valid) {
				this.next = () => this.back();
				this.requestSave();
				// this.back();
			} else if (!this.valid && this.$refs.form.errorBag) {
				const id = Object.entries(this.$refs.form.errorBag).find(x => x[1] == true)[0];
				if (id) document.getElementById(`input-${id}`).scrollIntoView();
			}
		},
		async saveAndNext() {
			this.loading = true;
			if (!this.isViewMode) {
				this.$refs.form.validate();
				if (!this.$v.$invalid && this.valid) {
					this.next = () => this.$router.push({
						name: 'categoryArt',
						params: { cGuid: this.cGuid },
					});
					this.requestSave();
				} else if (!this.valid && this.$refs.form.errorBag) {
					const id = Object.entries(this.$refs.form.errorBag).find(x => x[1] == true)[0];
					if (id) document.getElementById(`input-${id}`).scrollIntoView();
				}
			} else {
				this.$router.push({
					name: 'showcategoryArt',
					params: { cGuid: this.cGuid },
				});
			}
			this.loading = false;
		},
		backToOverview() {
			this.$router.push({
				name: 'competitionapproval',
			});
		},
		back() {
			this.$router.go(-1);
		},
		async searchOrgas(val) {
			const { value } = val.target;
			if (value && value.trim().length >= 3) {
				this.owner.items = await this.GET_ORGANIZATIONS_BY_NAME(value);
			}
		},
		async getOwnerItems() {
			this.regionGuid.loading = true;
			this.owner.items = await this.GET_ORGANIZATION_BY_GUID(this.owner.selected);
			if (!this.pristineComp.owner.text) {
				const index = this.owner.items.findIndex(x => x.value == this.pristineComp.owner.value);
				if (index != -1) this.pristineComp.owner = this.owner.items[index];
			}
			this.regionGuid.loading = false;
		},
		async getRegionOrganization() {
			this.regionGuid.loading = true;
			this.regionGuid.items = await this.GET_ORGANIZATIONS_BY_TYPE('Region');
			if (!this.pristineComp.regionGuid.text) {
				const index = this.regionGuid.items.findIndex(x => x.value == this.pristineComp.regionGuid.value);
				if (index != -1) this.pristineComp.regionGuid = this.regionGuid.items[index];
			}
			this.regionGuid.loading = false;
		},
		async getAreaOrganization() {
			this.areaGuid.loading = true;
			this.areaGuid.items = await this.GET_ORGANIZATIONS_BY_TYPE_PARENT({ type: 'Area', parent: this.regionGuid.selected });
			if (!this.pristineComp.areaGuid.text) {
				const index = this.areaGuid.items.findIndex(x => x.value == this.pristineComp.areaGuid.value);
				if (index != -1) this.pristineComp.areaGuid = this.areaGuid.items[index];
			}
			this.areaGuid.loading = false;
		},
		async getDistrictOrganization() {
			this.districtGuid.loading = true;
			this.districtGuid.items = await this.GET_ORGANIZATIONS_BY_TYPE_PARENT({ type: 'District', parent: this.regionGuid.selected });
			if (!this.pristineComp.districtGuid.text) {
				const index = this.districtGuid.items.findIndex(x => x.value == this.pristineComp.districtGuid.value);
				if (index != -1) this.pristineComp.districtGuid = this.districtGuid.items[index];
			}
			this.districtGuid.loading = false;
		},
		async requestSave() {
			this.loading = true;
			if (this.isStatusResetting) {
				this.showConfirmOverwrite = true;
			} else {
				await this.create();
				this.next();
			}
			this.loading = false;
		},
		async onConfirmClose() {
			this.loading = true;
			this.showConfirmOverwrite = false;
			if (this.confirmOverwrite) {
				await this.create();
				this.next();
			}
			this.loading = false;
		},
		async create() {
			this.$v.$touch();

			if (!this.$v.$invalid && this.valid && this.confirmOverwrite) {
				let link = null;
				this.writeDTO();
				if (this.isEditMode) {
					link = this.CompApprLinks.find(x => x.rel === 'update_comp');
				} else {
					link = this.CompApprLinks.find(x => x.rel === 'new');
				}

				if (link) {
					try {
						this.modelState = {};
						if (this.isEditMode) {
							await this.UPDATE_COMP_APPROVAL({ newCompApproval: this.Competition, link, cGuid: this.cGuid });
						} else {
							this.newComp = await this.NEW_COMP_APPROVAL({ newCompApproval: this.Competition, link });
						}
					} catch (e) {
						console.log(e);
						if (e.response.status === 422) {
							this.modelState = e.response.data;
							if (this.modelError()) {
								throw new Error(this.modelError());
							}
						}

						throw e;
					} finally {
						this.loading = false;
					}
				}
			}
		},
		formattedDate(date) {
			return date
				? this.$moment(date).format('DD.MM.YYYY')
				: '';
		},
		errors(name) {
			const errors = [];
			const apiErrors = this.validateProperty(name);
			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			return errors;
		},
		writeDTO() {
			this.Competition.name = this.name;
			this.Competition.ownerOrganizationId = this.owner.selected;
			this.Competition.startDate = `${this.startDate} ${this.startTime}`;
			this.Competition.endDate = this.endDate === null ? this.startDate : this.endDate;
			this.Competition.competitionApprovalType = this.type.selected;
			this.Competition.entryEndDate = this.closingDate;
			this.Competition.nation = this.country.selected;
			this.Competition.nonProfit = this.nonProfit;
			this.Competition.nonProfitReason = this.nonProfitReason;
			this.Competition.fees = this.fees;
			this.Competition.firstTimeEvent = this.firstTimeEvent;
			this.Competition.contact_PersonTitel = this.contact.title.selected;
			this.Competition.contact_Firstname = this.contact.firstName;
			this.Competition.contact_Lastname = this.contact.lastName;
			this.Competition.contact_Street = this.contact.street;
			this.Competition.contact_StreetAddition = this.contact.streetAdd;
			this.Competition.contact_Zip = this.contact.zip;
			this.Competition.contact_Town = this.contact.town;
			this.Competition.contact_Phone = this.contact.phone;
			this.Competition.contact_Mobile = this.contact.mobile;
			this.Competition.contact_Fax = this.contact.fax;
			this.Competition.contact_Email = this.contact.email;
			this.Competition.contact_Website = this.contact.web;
			this.Competition.contact_ExtraInfos = this.contact.note;
			this.Competition.linkEntrySystem = this.linkEntrySystem;
			this.Competition.eventLocation_Startplace = this.competition.startLocation;
			this.Competition.eventLocation_Street = this.competition.street;
			this.Competition.eventLocation_Zip = this.competition.zip;
			this.Competition.eventLocation_Town = this.competition.town;
			this.Competition.eventLocation_Latitude = this.competition.gps.lat;
			this.Competition.eventLocation_Longitude = this.competition.gps.lng;
			this.Competition.eventLocation_Region_Id = this.regionGuid.selected;
			this.Competition.eventLocation_Area_Id = this.areaGuid.selected;
			this.Competition.eventLocation_District_Id = this.districtGuid.selected;
			this.Competition.offsite_Arrival_Street = this.competition.alt.street;
			this.Competition.offsite_Arrival_Zip = this.competition.alt.zip;
			this.Competition.offsite_Arrival_Town = this.competition.alt.town;
			this.Competition.offsite_Arrival_Latitude = this.competition.alt.gps.lat;
			this.Competition.offsite_Arrival_Longitude = this.competition.alt.gps.lng;
		},
		readFromDTO() {
			this.name = this.Competition.name;
			this.owner.selected = this.Competition.ownerOrganizationId;
			this.startDate = this.$moment(this.Competition.startDate).format('YYYY-MM-DD');
			this.startTime = this.$moment(this.Competition.startDate).format('HH:mm');
			this.endDate = this.Competition.endDate ? this.$moment(this.Competition.endDate).format('YYYY-MM-DD') : this.Competition.endDate;
			this.type.selected = this.Competition.competitionApprovalType;
			this.closingDate = this.Competition.entryEndDate ? this.$moment(this.Competition.entryEndDate).format('YYYY-MM-DD') : this.Competition.entryEndDate;
			this.country.selected = this.Competition.nation;
			this.nonProfit = this.Competition.nonProfit;
			this.nonProfitReason = this.Competition.nonProfitReason;
			this.fees = this.Competition.fees;
			this.firstTimeEvent = this.Competition.firstTimeEvent;
			this.contact.title.selected = this.Competition.contact_PersonTitel;
			this.contact.firstName = this.Competition.contact_Firstname;
			this.contact.lastName = this.Competition.contact_Lastname;
			this.contact.street = this.Competition.contact_Street;
			this.contact.streetAdd = this.Competition.contact_StreetAddition;
			this.contact.zip = this.Competition.contact_Zip;
			this.contact.town = this.Competition.contact_Town;
			this.contact.phone = this.Competition.contact_Phone;
			this.contact.mobile = this.Competition.contact_Mobile;
			this.contact.fax = this.Competition.contact_Fax;
			this.contact.email = this.Competition.contact_Email;
			this.contact.web = this.Competition.contact_Website;
			this.contact.note = this.Competition.contact_ExtraInfos;
			this.linkEntrySystem = this.Competition.linkEntrySystem;
			this.competition.startLocation = this.Competition.eventLocation_Startplace;
			this.competition.street = this.Competition.eventLocation_Street;
			this.competition.zip = this.Competition.eventLocation_Zip;
			this.competition.town = this.Competition.eventLocation_Town;
			this.competition.gps.lat = this.Competition.eventLocation_Latitude;
			this.competition.gps.lng = this.Competition.eventLocation_Longitude;
			this.regionGuid.selected = this.Competition.eventLocation_Region_Id;
			this.areaGuid.selected = this.Competition.eventLocation_Area_Id;
			this.districtGuid.selected = this.Competition.eventLocation_District_Id;
			this.competition.alt.street = this.Competition.offsite_Arrival_Street;
			this.competition.alt.zip = this.Competition.offsite_Arrival_Zip;
			this.competition.alt.town = this.Competition.offsite_Arrival_Town;
			this.competition.alt.gps.lat = this.Competition.offsite_Arrival_Latitude;
			this.competition.alt.gps.lng = this.Competition.offsite_Arrival_Longitude;

			this.pristineComp.startDate = this.startDate;
			this.pristineComp.owner.value = this.owner.selected;
			this.pristineComp.regionGuid.value = this.regionGuid.selected;
			this.pristineComp.areaGuid.value = this.areaGuid.selected;
			this.pristineComp.districtGuid.value = this.districtGuid.selected;
			this.pristineComp.town = this.competition.town;
		},
	},
};
</script>
